<template>
    <div class="payment">
    
      <div class="container page_banner ">
        <div class='page_width'>
            <div class="banner_gruop">
                <div class="banner_title">Official Payment Center</div>
               
            </div>
            
        </div>
      </div>
   
      <div class="container pay_container" >
        <div class="page_width ">
          <div class="grid grid_xs_gap " style="">
            <div class="grid_md_3 grid_sm_12 pay_left_con">
              <div class="banner_img"><img src="../../assets/image/yytb.png" alt="" class="game_icon"></div>
                <div class="banner_item">
                  <div class="item_inner">
                    <div class="item_title color3">Galaxy Chaos Survivors</div>
                   <div class="item_text ">An action-packed adventure game where players navigate through cosmic chaos, battling enemies and collecting power-ups to survive increasingly challenging waves of galactic threats. With stunning visuals and immersive gameplay, Galaxy Chaos Survivors offers endless hours of entertainment.</div>
                   <!-- <div class="item_text" >Missions include rescuing the princess, killing goblins, opening chests, and gathering gold. Avoid lava or face defeat! Some levels combine tasks for extra challenge. Become the hero of your kingdom!</div> -->
                  </div>
                </div>
            </div>
            <div class="grid_md_8 grid_sm_12">
              <div class="page_pay_title">
            <div class="title_name ">Please enter the user info</div>
            <div class="pay_group">
                <div class="pay_form flex">
                    <div class="form_label flex_center pointer"><div class="color7">email</div><div class="label_solt"><img src="../../assets/image/arrow_down.png" alt=""></div></div>
                    <div class="form_value">
                        <input type="text" v-model="email" placeholder="Please enter your in-game email">
                    </div>
                    <!-- <div class="form_btn flex_center pointer">Get</div> -->
                </div>
            </div>
            <div class="tips">Please enter the correct user information! lf the information is filed in incorrectly, the recharge will be abnormal.</div>
          </div>
          <div></div>
          <div class="page_thumb">
            <div class="page_container cate_container">
             <div class="grid grid_md_gap grid_xs_gap grid_sm_gap">
              <div class="grid_md_4 grid_xs_4 grid_sm_6" v-for="(i,index) in glanceList" :key="index" @click="toPayment(i)">
                <div class="item_group">
                  <div class="item_box pointer">
                    <div class="item_info">
                        <div class="item_icon"><img :src="i.image" alt=""></div>
                        <div class="item_count">{{ i.num }}</div>
                    </div>
                    <div class="item_amount">$ {{ i.price }}</div>
                  </div>
                </div>
              </div>
             </div>
            </div>  
          </div> 
            </div>
          </div>
               
        </div>
      </div>

      <!-- <Footer></Footer> -->
      <!-- <checkout  @closeDialog="closeCheck"  :orderId='orderId' :channelTag="channelTag" :stripeKey="stripeKey" v-if="showCheckout"></checkout> -->
    </div>
     
  </template>
  
  <script>
  import{divide} from '../../utils/filters'
  import checkout from "../../components/checkout.vue";

  import axios from 'axios';
  // import Footer from '../../components/footer.vue';
  
  export default {
    components: {
 
      checkout,
      // Footer
    },
    data () {
      return {
        tabId:'',
        screenWidth: document.body.clientWidth,
        glanceList:[
        ],
        showCheckout:false,
        channelTag:'STRIPE_PAY',
        orderId:'',
        stripeKey:'',
        shopName:'',
        email:'',
        gameType:5,
        payForm:{ 
         email:'',
         year:'',
         month:'',
         cvv:'',
         ip:'',
         cardNo:'',
         orderId:'',
         token:'',
       },
      }
    }, 
    created () {
     this.email = this.$route.query.email?this.$route.query.email:''
     this.getData()
     this.getIp()
    },
    methods: {
     getData(){
      this.$store.commit('setLoad',true)
      let gameType = this.gameType
      this.$axios({
                url:'/game_api/order/getProductList?gameType='+gameType,
                method:'get',
                data:{  
                },
                headers: {
                // 'Content-type':'application/json'
                }
            })
            .then(res=>{
              this.$store.commit('setLoad',false)
              let data = res.data.data
              this.glanceList = data.map(v=>{
                v.price = divide(v.price)
                return v
              })
              console.log('data',this.glanceList)
            })
            .catch(err=>{
              this.$store.commit('setLoad',false)
            })

     }, 
     toPayment(item){
      if(!this.email){
        this.$Message.error('Please fill in your email address')
        return
      }
      this.$store.commit('setLoad',true)
      let gameType = this.gameType
      this.$axios({
                url:'/game_api/order/createOrder',
                method:'post',
                data:{  
                  goodsId:item.id,
                  goodsNum:1,
                  account:this.email,
                  channelId:83,
                  gameType:gameType,
                },
                headers: {
                // 'Content-type':'application/json'
                }
            })
            .then(res=>{
              this.$store.commit('setLoad',false)
              let data = res.data
              if(data.code == 200){
                // this.showCheckout = true
                this.stripeKey = data.data.publicKey
                this.channelTag = data.data.channelTag
                this.orderId = data.data.externalId
                this.payment()
              
              }
              else{
                this.$Message.error(data.msg)
              }
              console.log('data',res.data)
            })
            .catch(err=>{
              this.$store.commit('setLoad',false)
            })
     },     
     payment(){
        let _this = this
        let payForm = this.payForm
        let orderNo = this.orderId
        let ip = payForm.ip
        
        this.$store.commit('setLoad',true)
        this.$axios({
                  url:'/game_api/order/pay',
                  method:'post',
                  data:{  
                    orderNo:orderNo,
                    ip:ip,
                   
                  },
                  headers: {
                  // 'Content-type':'application/json'
                  }
              })
              .then(res=>{
                this.$store.commit('setLoad',false)
                let data = res.data
                if(data.code == 200){
                  if(data.data.respCode ==10000){
                    _this.$Message.success(data.data.respMessage)
                   
                  }
                  else if(data.data.respCode !=10000){
                  
                    if(data.data.respCode == 10002){
                      if (data.data.payUrl) {
                          console.log('res.data.payUrl',data.data.payUrl)
                          window.open(data.data.payUrl)
                          return
                        
                      }else{
                        _this.$Message.error(data.data.respMessage)
                      }
                    }else{
                      _this.$Message.error(data.data.respMessage)
                    }
                  }
                }
                else{
                  _this.$Message.error(data.msg)
                }
                console.log('data',res.data)
              })
              .catch(err=>{
                this.$store.commit('setLoad',false)
              })
      
      },
     async getIp () {
        try {
          let res = await axios.get('https://ipv4.icanhazip.com/')
          this.payForm.ip = res.data.replace(/[\n\t\s]+/g, '');
          console.log( this.payForm.ip,'公网ip')
          return this.payForm.ip
        } catch (err) {
            setTimeout(() => {
            this.getIp()
            }, 2000)
        }
      },
      windowScroll() {
        // 滚动条距离页面顶部的距离
        // 以下写法原生兼容
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if(scrollTop > 0){
          this.$store.state.isFloat = true
        }else{
          this.$store.state.isFloat = false
        }
  
      },
      closeCheck(value){
        this.showCheckout = value
      },
     
   
  
      
      
    },
    mounted () {
      // window.onresize = () => {
      //   this.screenWidth = window.innerWidth
      // },
      // window.addEventListener('scroll', this.windowScroll);
      
    },
    computed:{
     
      mySwiper(){
        return this.$refs.mySwiper.swiper
      },
    
    },
    watch: {
      // "$store.state.page": {
      //   handler: function (newVal) {
      //     this.name = newVal
      
      //   }
      // },
      
    },
    beforeDestroy() {
      // window.removeEventListener('scroll', this.windowScroll);
    },
  
  
    
  }
  </script>
  <style lang='scss' scoped>
  .payment {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: -80px;
    .page_banner{
        background-image:url(../../../public/bg/bnbg.png);
        .banner_title{
          position: relative;
          z-index: 1;
       
        }
        .title_bg{
          position: absolute;
          width: 250px;
          height: auto;
          top:60%;
          left:50%;
          transform: translate(-50%, -50%);
         
        }
    }
    .pay_container{
      padding-top:80px;
      .pay_left_con{
        padding:20px;
        border-radius: 8px;
        background: #12266C;
        height: min-content;
      }
    }
    .pay_banner{
      display: grid;
      grid-template-columns:1fr 2fr;
      margin-top:40px;
      margin-bottom:40px;
      grid-column-gap:20px;
      .banner_grid{
  
        padding:20px;
        background: #3D473F;
        border-radius: 10px 10px 10px 10px;
        .banner_img{  
          //  padding-right:80px;
            img{
                width: 100%;
                height: auto;
            }
        }
        .banner_item{
         color:$theme_color1;
         text-align: left;
         
            
        }
      }
     
     
      
    }
    .item_inner{
          height: 100%;
          display: flex;
          flex-direction: column;
         
          color:$theme_color1;
          text-align: center;
          // justify-content: space-between;
          .item_title{
                font-size: 30px;
                font-weight: bold;
                margin-bottom:20px;
            }
            .item_text{
                font-family: PingFang SC, PingFang SC;
                font-size: 18px;  
                margin-bottom:20px;
                line-height: 2;
              
            }
         }
    .page_top{
      margin-top:80px;
    }
  
    .page_pay_title{
        text-align: left;
        .title_name{
            font-size: 40px;
            color:$theme_color3;
        }
    }
    .pay_group{
        color:$theme_color4;
        font-size: 20px;
        margin-top:30px;
        .pay_form{
            .form_label{
                border:2px solid $theme_color2;
                border-radius: 12px;
                background:$theme_color1;
                padding:8px 15px;
                margin-right:20px;
                .label_solt{
                    width: 20px;
                    height: 20px;
                    margin-left:10px;
                }
            }
            .form_value{
               
               width: 500px;
                margin-right: 20px;
                input{
                    width: 100%;
                    height: 100%;
                    border:2px solid $theme_color2;
                    border-radius: 12px;
                    background:$theme_color1;
                    padding:0 15px;
                }
            }
            .form_btn{
                background-image:url(../../../public/bg/get_btn.png);
                background-size: 100% 100%;
                width: 100px;
                color:$theme_color1;
            }
        }
    }
    .tips{
        font-size: 20px;
        color:$theme_color1;
        text-align: left;
        margin-top:18px;
    }
    .item_group{
        transition: all 0.35s ease;
        position: relative;
        top:0px;
        &:hover{
            top:-10px;
            .item_icon{
                transform: scale(1.02);
            }
        }
      .item_box{
        position: relative;
        border-radius: 8px;
        overflow: hidden;
        .item_info{
          // padding:20px 20px 100px;
          color:$theme_color2;
          font-size: 40px;
          background-image:url(../../../public/bg/sp_tu.png);
          background-size: 100% 100%;
          .item_icon{
           padding:20px;
           transition: all 0.35s ease;
        //    transform: scale(1);
          }
          .item_count{
            margin-top:-30px;
            padding-bottom:20px;
            font-size: 20px;
          }
          
        }
        .item_amount{
            // position: absolute;
            width: 100%;
            padding:20px;
            background-color:$theme_color1;
            color:$theme_color10;
            font-size: 30px;
          }
      }
      .group_half{
       
       .half_container{
         color:$theme_color2;
         text-align: left;
         &:last-child{
           margin-top:60px;
         }
         .half_title{
           font-size: 30px;
         }
         .half_msg{
           font-size: 24px;
           margin-top:20px;
 
         }
         .half_text{
           font-size: 14px;
           line-height: 40px;
         }
       }
       .half_wrap{
         text-align: left;
         background:$theme_color1;
         border-radius: 12px;
         padding:20px 40px;
         margin-bottom:20px;
         .wrap_title{
           color:$theme_color3;
           font-size: 20px;
         }
         .wrap_text{
           color:$theme_color2;
           font-size: 14px;
           margin-top:10px;
         }
       }
       .half_title_group{
         color:$theme_color2;
         text-align: left;
         .title_h{
           font-size: 48px;
         }
         .title_p{
           font-size: 26px;
         }
       }
       .half_content{
         color:$theme_color2;
         margin-top:20px;
         text-align: left;
         .half_title{
           color:$theme_color3;
           font-size: 40px;
         }
         .half_text{
           font-size: 18px;
           font-weight: 800;
           font-family: PingFang SC, PingFang SC;
         }
       }
     }
     
    }

    
    .cate_thumb{
      padding:0 50px 24px;
    }
    .cate_container{
        padding:50px 0 0px; 
    }
   
    
   

  
  }
  @media screen and (max-width:991px){
    .page_banner{
     
      .banner_title{
        font-size: 30px!important;
       
      }
      .title_bg{
        width: 150px!important;
      }
      .banner_grid{
        grid-column-gap:20px;
      }
      .item_inner {
        
        text-align: left;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-evenly;
       
        font-family: PingFang SC, PingFang SC;
        .item_text {
          font-size: 12px!important;
        }
      }
      .game_icon{
        width:100%;
        height: auto;
      }
    }
   
    .title_name {
      font-size: 28px!important;
    }
    .tips{
      font-size: 14px!important;
    }
    // .item_amount{
    //   font-size: 20px!important;
    // }
 
}
  </style>
 
